<template>
  <div
    v-if="order"
    :key="order.reference_id"
    :style="orderStyle"
  >
    <v-layout
      row
      align-center
      @click="showOrder"
    >
      <v-flex
        xs10
        class="nowrap-text"
        :style="nameStyle"
      >
        {{ printDate(order.created_at) }}
      </v-flex>
      <v-flex
        xs2
        text-xs-right
      >
        <v-btn
          icon
          small
        >
          <v-icon
            :color="theme.btn_color_secondary"
            small
          >fa-chevron-right</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
    <div>
      <v-layout
        v-if="posStatus.canResend"
        row
        align-center
      >
        <v-flex class="sub-text">
          <span :style="nameStyle">{{ $t('status') }}:</span>
          <span class="status" :style="statusStyle(posStatus.success)">{{ posStatus.text }}</span>
          <v-icon
            v-if="this.count < 5 || this.isLoading"
            :color="theme.orders_fail_color"
            small
            class="ml-2"
          >fas fa-circle-notch fa-spin</v-icon>
          <v-btn
            v-else
            dark
            class="sub-text"
            small
            :color="theme.btn_color_secondary"
            @click="getPosStatus"
          >{{ $t('check_status') }}</v-btn>
        </v-flex>
      </v-layout>
      <v-layout
        v-else
        row
        align-center
      >
        <v-flex
          xs12
          class="sub-text"
        >
          <span :style="nameStyle">{{ $t('status') }}:</span>
          <span class="status" :style="statusStyle(posStatus.success)">{{ posStatus.text }}</span>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex'

export default {
  props: {
    id: {
      type: Number,
      default: null
    },
    orderStyle: {
      type: Object,
      default: () => ({
        cursor: 'pointer'
      })
    },
    isPending: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      timer: null,
      count: 0,
      isLoading: false
    }
  },
  computed: {
    ...mapGetters('config', [
      'theme', 'withQueueNo'
    ]),
    ...mapGetters('member', [
      'isMember'
    ]),
    ...mapGetters('order', [
      'orders'
    ]),
    nameStyle () {
      return {
        color: this.theme.orders_name_color
      }
    },
    order () {
      return this.orders.find(o => parseInt(o.id) === this.id)
    },
    posStatus () {
      switch (this.order.pos_status) {
        case 'order completed':
          return {
            success: true,
            canResend: false,
            eText: 'submitted',
            text: this.$t('submitted')
          }
        case 'item not found':
        case 'item unavailable':
        case 'item not available':
          return {
            success: false,
            canResend: false,
            eText: 'item_unavailable',
            text: this.$t('item_unavailable')
          }
        case 'order expired':
          return {
            success: false,
            canResend: false,
            eText: 'order_expired',
            text: this.$t('order_expired')
          }
        case 'fail':
          return {
            success: false,
            canResend: false,
            eText: 'fail',
            text: this.$t('fail')
          }
        case 'cart already has discount coupon applied':
        case 'another member coupon used. only 1 member can use coupon':
          return {
            success: false,
            canResend: false,
            eText: 'fail',
            text: 'Fail to apply coupon.'
          }
        default:
          return {
            success: false,
            canResend: this.isPending,
            eText: 'pending',
            text: this.$t('pending')
          }
      }
    }
  },
  methods: {
    statusStyle (success) {
      if (success) {
        return {
          color: this.theme.orders_success_color
        }
      }
      return {
        color: this.theme.orders_fail_color
      }
    },
    showOrder () {
      this.$router.push({ name: 'order2', params: { id: this.order.id.toString() }})
    },
    async getPosStatus () {
      this.isLoading = true
      await this.retryFetchPosStatus()
      this.isLoading = false
    },
    async retryFetchPosStatus () {
      if (this.posStatus.canResend) {
        if (this.posStatus.eText === 'pending') {
          await this.$store.dispatch('order/fetchMobileOrderStatus', this.order.reference_id)
        } else {
          await this.$store.dispatch('order/resendMobileOrder', this.order.reference_id)
        }
      }
    },
    printDate (d) {
      const d2 = moment(d)
      const today = moment()
      const yesterday = moment().subtract(1, 'day')
      if (d2.isSame(today, 'day')) return this.$t('today_at') + d2.format('h:mm A')
      if (d2.isSame(yesterday, 'day')) return this.$t('yesterday_at') + d2.format('h:mm A')
      return d2.format('D MMMM YYYY \\at h:mm A')
    }
  },
  async mounted () {
    // Loop for 5 times (previously I do only 2 times, it is not enough)
    this.timer = setInterval(async () => {
      if (this.count >= 5 || !this.posStatus.canResend) {
        clearInterval(this.timer)
      } else {
        await this.retryFetchPosStatus()
        this.count++
      }
    }, 2000)
  },
  beforeDestroy () {
    clearInterval(this.timer)
  }
}
</script>

<style scoped>
.status {
  font-weight: 500;
}
.nowrap-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 500;
}
.sub-text {
  font-size: small;
}
</style>



// WEBPACK FOOTER //
// src/components/OrderLine2.vue